import React from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper } from "swiper/react";
import { ReactComponent as ArrowRight } from "../../../assets/icons/cft/arrow-right.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/cft/arrow-left.svg";

export const CarouselWrapper = ({
  children,
  showNav = true,
  showPag = true,
  onPrev = () => null,
  onNext = () => null,
  swiperRef,
  isSliderOn = true,
  initialSlide = 0,
  slidesPerViewSmall = 2,
  slidesPerViewMed = 3,
  slidesPerViewBig = 3,
  isLoading = false,
}) => {
  if (isSliderOn)
    return (
      <Swiper
        ref={swiperRef}
        initialSlide={initialSlide}
        modules={[Navigation, Pagination]}
        pagination={{
          type: "custom",
          renderCustom(swiper, current, total) {
            return showPag
              ? `${`0${current}`.slice(-2)} / ${`0${total}`.slice(-2)}`
              : "";
          },
        }}
        slidesPerView={1.2}
        spaceBetween={20}
        breakpoints={{
          576: {
            slidesPerView: slidesPerViewSmall,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: slidesPerViewMed,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: slidesPerViewBig,
            spaceBetween: 20,
          },
        }}
      >
        {children}
        {showNav && (
          <div className="carousel-navigation">
            <div
              onClick={e => {
                if (!isLoading) {
                  e.preventDefault();
                  const swp = swiperRef.current.swiper;
                  if (swp.isBeginning) {
                    onPrev();
                  } else swp.slidePrev();
                }
              }}
              className="carousel-navigation__arrow"
            >
              <ArrowLeft />
            </div>
            <div
              onClick={e => {
                if (!isLoading) {
                  const swp = swiperRef.current.swiper;
                  e.preventDefault();
                  if (swp.isEnd) {
                    onNext();
                  }
                  swp.slideNext();
                }
              }}
              className="carousel-navigation__arrow"
            >
              <ArrowRight />
            </div>
          </div>
        )}
      </Swiper>
    );
  return <div className="Sections__articles">{children}</div>;
};
